import React from "react";
import { DealFlowScreen } from "@/components/deal-flow/DealFlowScreen";
import TopSellingOpportunities from "@/components/deal-flow/TopSellingOpportunities";

/**
 * Quick Winner (formerly Deal Flow) — retail-arbitrage lead list
 * (Retailers → Walmart), backed by the real persisted sourcing pipeline
 * (no demo fixtures).
 *
 * Reverse Sourcing and Saved Searches are semantically distinct datasets and
 * are NOT served from the Quick Winner feed. They render a truthful "not wired
 * to real data yet" state instead of sharing Quick Winner's opportunities.
 */
export default function DealFlow({ title = "Quick Winner" }) {
  if (title === "Top-Selling Products") {
    return <TopSellingOpportunities />;
  }
  if (title === "Reverse Sourcing" || title === "Saved Searches") {
    return <UnavailableResearchView title={title} />;
  }
  return <DealFlowScreen title={title} />;
}

function UnavailableResearchView({ title }) {
  return (
    <div className="df-root" data-testid="research-unavailable">
      <header className="mb-1">
        <h1 className="text-ptitle text-ink-primary m-0">{title}</h1>
      </header>
      <div className="mt-6 py-16 text-center text-ink-muted">
        <p className="m-0 text-[15px] font-semibold text-ink-primary">
          {title} isn't connected to live data yet.
        </p>
        <p className="mt-2 mb-0 text-compact text-ink-muted">
          This view is kept separate from Quick Winner and will be wired to its own
          data source when available.
        </p>
      </div>
    </div>
  );
}
